<div class="spinner-overlay">
  <div class="spinner-box">
    <div class="spinner"></div>

    <p class="spinner-text">
      {{ mensaje }}
    </p>
  </div>
</div>
